<template>
  <div id="app">
    <router-view></router-view>
    <video id="background-video" autoplay loop muted>
      <source src="./assets/Animation.mp4" type="video/mp4">
    </video>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
#app {
  font-family: "KHMenu", Roboto, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}
html {
  overflow-x: hidden;
}
body {
  --highlight: #FFCC99;
  --white: #FFFFFF;
  --blue-light: #AACCFF;
  --blue: #6677BB;
  --blue-dark: #4A5A88;
  --indigo: #1A1A33;
  --black: #000000;
  margin: 0;
  font-size: 16px;
  font-family: 'KHMenu', Roboto, sans-serif;
  color: var(--white);
  background-color: var(--black);
  overflow-x: hidden;
  overflow-y: scroll;
}

// Fonts
@font-face {
  font-family: "KHMenu";
  src: url(assets/fonts/KHMenu.woff2) format("woff2");
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: "KHGummi";
  src: url(assets/fonts/KHGummi.woff2) format("woff2");
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: "KHTitle";
  src: url(assets/fonts/KHTitle.woff2) format("woff2");
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: "KHData";
  src: url(assets/fonts/KHData.woff2) format("woff2");
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: "KHScala";
  src: url(assets/fonts/KHScala.woff2) format("woff2");
  font-style: normal;
  font-display: block;
}
@font-face {
  font-family: "KHScalaScript";
  src: url(assets/fonts/KHScalaScript.woff2) format("woff2");
  font-style: normal;
  font-display: block;
}
h1 {
  font-family: "KHGummi", Roboto, sans-serif;
  font-size: calc(1em + 2.5vw);
  font-weight: normal;
  margin: 0;
}
h2 {
  font-family: "KHGummi", Roboto, sans-serif;
  font-size: calc(1em + 1.2vw);
  font-weight: normal;
  margin: 0;
}
h3 {
  font-size: calc(1em + 0.7vw);
  font-weight: normal;
  margin: 0;
}
p {
  font-family: "KHMenu", Roboto, sans-serif;
  font-size: calc(0.75em + 0.75vw);
  font-weight: normal;
}
a {
  text-decoration: none;
  color: var(--blue-light);
  transition: 0.1s;
}
a:hover {
  color: var(--white);
}

// Text
.header {
  padding-top: 1.5em;
  filter: drop-shadow(0 0 0.25em var(--indigo))
          drop-shadow(0 0 0.125em var(--indigo));
}
.scala {
  font-family: KHScala;
  margin: 0;
}
.textbox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  padding: 1.5em 5vw;
  filter: drop-shadow(0 0 0.5em var(--indigo))
          drop-shadow(0 0 0.25em var(--indigo))
}

// Buttons
.button-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 1em;
}
button, input {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "KHMenu", Roboto, sans-serif;
  padding: 0.25em 2.5em 0.5em;
  margin: 0.25em;
  color: var(--blue-light);
  background: linear-gradient(to bottom, var(--black), var(--black) 50%, var(--indigo) 50%, var(--indigo));
  background-size: 100% 5px;
  outline: none;
  border: solid 2px var(--blue);
  border-radius: 100vw;
  filter: drop-shadow(0 0 0.5em var(--indigo));
  cursor: pointer;
  transition: 0.1s;
}
button:hover, input:hover {
  border-color: var(--blue-light);
  color: var(--white);
}
button:active {
  background: var(--blue-light);
  border-color: var(--blue-light);
  color: var(--indigo);
}
::placeholder {
  color: var(--blue-dark);
}

// Preview
.preview {
  width: 100%;
  aspect-ratio: auto 24/71;
  filter: drop-shadow(0 0 1em var(--indigo))
          drop-shadow(0 0 0.5em var(--indigo));
}

// Translaion
.translation {
  width: 100%;
  border: solid 2px var(--blue-light);
  border-radius: 0.5em;
  margin-bottom: 4em;
  filter: drop-shadow(0 0 1em var(--indigo))
          drop-shadow(0 0 0.5em var(--indigo));
}

// Background
#background-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -100;
}
</style>